import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { UPSConstant } from '@app/common/constant/ups.constant';

@Component({
  selector: 'sales-tax-popup',
  templateUrl: './sales-tax-popup.component.html',
  styleUrls: ['./sales-tax-popup.component.css']
})
export class SalesTaxPopupComponent implements OnInit {

  @Input()
  show: boolean = false;

  @Output()
  closePopup = new EventEmitter<boolean>();

  @Output()
  chooseOption = new EventEmitter<string>();

  UPS = UPSConstant.UPS;
  UPSSignature = UPSConstant.UPSSignature;

  constructor() { }

  ngOnInit(): void {
  }

  handleOnClickClosePopup(): void {
    this.closePopup.emit(false);
  }

  @HostListener('window:popstate', ['$event'])
  handleOnClickBackHistory(): void {
    this.handleOnClickClosePopup();
  }

  handleOnClickPopupContainer(_event: any): void {
    const element = _event.target;
    if (element) {
      const classList = element.classList;
      if (classList.contains('popup')) {
        this.handleOnClickClosePopup();
      }
    }
  }

  handleOnClickUPSOption(option: string): void {
    this.chooseOption.emit(option);
    this.handleOnClickClosePopup();
  }
}
